module.exports = __webpack_public_path__ + "static/media/400414_01.87bab633.png";